import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "src/app/core/guard/auth.guard";
import { BaseComponent } from "./base/base.component";

const routes: Routes = [
  {
    path: "",
    component: BaseComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: "dashboard",
        loadChildren: () =>
          import("./../../views/pages/dashboard/dashboard.module").then(
            (m) => m.DashboardModule,
          ),
      },
      {
        path: "",
        redirectTo: "dashboard",
        pathMatch: "full",
      },
      {
        path: "user",
        loadChildren: () =>
          import("./../../views/pages/master/user/user.module").then(
            (m) => m.UserModule,
          ),
      },
      {
        path: "profile/:id/:actionInfo",
        loadChildren: () =>
          import("./../../views/pages/profile/profile/profile.module").then(
            (m) => m.ProfileModule,
          ),
      },
      {
        path: "incomereport",
        loadChildren: () =>
          import("./../../views/pages/reports/incomereport/incomereport.module").then(
            (m) => m.IncomeReportModule,
          ),
      },
      {
        path: "distancereport",
        loadChildren: () =>
          import("./../../views/pages/reports/distancereport/distancereport.module").then(
            (m) => m.DistanceReportModule,
          ),
      },
      {
        path: "refuelreport",
        loadChildren: () =>
          import("./../../views/pages/reports/refuelreport/refuelreport.module").then(
            (m) => m.RefuelReportModule,
          ),
      },
      {
        path: "emptytruckreport",
        loadChildren: () =>
          import("./../../views/pages/reports/emptytruckreport/emptytruckreport.module").then(
            (m) => m.EmptyTruckReportModule,
          ),
      },
      {
        path: "exportinvoice",
        loadChildren: () =>
          import("./../../views/pages/exportinvoice/exportinvoice.module").then(
            (m) => m.ExportInvoiceModule,
          ),
      },
      {
        path: "tripreport",
        loadChildren: () =>
          import("./../../views/pages/reports/tripreport/tripreport.module").then(
            (m) => m.TripReportModule,
          ),
      },
      {
        path: "tripstatusreport",
        loadChildren: () =>
          import("./../../views/pages/reports/tripstatusreport/tripstatusreport.module").then(
            (m) => m.TripStatusReportModule,
          ),
      },
      {
        path: "podturnaround",
        loadChildren: () =>
          import("./../../views/pages/reports/podturnaround/podturnaround.module").then(
            (m) => m.PODTurnaroundModule,
          ),
      },
      {
        path: "manager",
        loadChildren: () =>
          import("./../../views/pages/master/manager/manager.module").then(
            (m) => m.ManagerModule,
          ),
      },
      {
        path: "fleet",
        loadChildren: () =>
          import("./../../views/pages/master/fleet/fleet.module").then(
            (m) => m.FleetModule,
          ),
      },
      {
        path: "customer",
        loadChildren: () =>
          import("./../../views/pages/master/customer/customer.module").then(
            (m) => m.CustomerModule,
          ),
      },
      {
        path: "driver",
        loadChildren: () =>
          import("./../../views/pages/master/driver/driver.module").then(
            (m) => m.DriverModule,
          ),
      },
      {
        path: "product",
        loadChildren: () =>
          import("./../../views/pages/master/product/product.module").then(
            (m) => m.ProductModule,
          ),
      },
      {
        path: "loadtype",
        loadChildren: () =>
          import("./../../views/pages/master/loadtype/loadtype.module").then(
            (m) => m.LoadtypeModule,
          ),
      },
      {
        path: "monthlytarget",
        loadChildren: () =>
          import("./../../views/pages/master/monthlytarget/monthlytarget.module").then(
            (m) => m.MonthlytargetModule,
          ),
      },
      {
        path: "fuellingpoint",
        loadChildren: () =>
          import("./../../views/pages/master/fuelpoint/fuelpoint.module").then(
            (m) => m.FuelpointModule,
          ),
      },
      {
        path: "wcalendar",
        loadChildren: () =>
          import("./../../views/pages/master/workingcalendar/workingcalendar.module").then(
            (m) => m.WorkingcalendarModule,
          ),
      },
      {
        path: "fuellog",
        loadChildren: () =>
          import("./../../views/pages/master/fuellog/fuellog.module").then(
            (m) => m.FuellogModule,
          ),
      },
      {
        path: "planninglog",
        loadChildren: () =>
          import("./../../views/pages/orders/planninglog/planninglog.module").then(
            (m) => m.PlanninglogModule,
          ),
      },
      {
        path: "trucktimelinedetails",
        loadChildren: () =>
          import("./../../views/pages/orders/planninglog/planninglog.module").then(
            (m) => m.PlanninglogModule,
          ),
      },
      {
        path: "unallocatedorder",
        loadChildren: () =>
          import("./../../views/pages/orders/unallocatedorder/unallocatedorder.module").then(
            (m) => m.UnallocatedorderModule,
          ),
      },
      {
        path: "trucktimeline",
        loadChildren: () =>
          import("./../../views/pages/orders/trucktimeline/trucktimeline.module").then(
            (m) => m.TrucktimelineModule,
          ),
      },
      {
        path: "calendar",
        loadChildren: () =>
          import("./../../views/pages/master/calendar/calendar.module").then(
            (m) => m.CalendarModule,
          ),
      },
      {
        path: "trailer",
        loadChildren: () =>
          import("./../../views/pages/master/trailer/trailer.module").then(
            (m) => m.TrailerModule,
          ),
      },
      {
        path: "tripdocumenttracker",
        loadChildren: () =>
          import("./../../views/pages/master/tripdocumenttracker/tripdocumenttracker.module").then(
            (m) => m.TripdocumenttrackerModule,
          ),
      },
      {
        path: "configuration",
        loadChildren: () =>
          import("./../../views/pages/master/configuration/configuration.module").then(
            (m) => m.ConfigurationModule,
          ),
      },
      {
        path: "palletsummary",
        loadChildren: () =>
          import("./../../views/pages/master/palletsummary/palletsummary.module").then(
            (m) => m.PalletsummaryModule,
          ),
      },
      {
        path: "mtdrevenue",
        loadChildren: () =>
          import("./../../views/pages/orders/mtdrevenue/mtdrevenue.module").then(
            (m) => m.MTDRevenueModule,
          ),
      },
      {
        path: "broker",
        loadChildren: () =>
          import("./../../views/pages/master/broker/broker.module").then(
            (m) => m.BrokerModule,
          ),
      },
      {
        path: "country",
        loadChildren: () =>
          import("./../../views/pages/master/country/country.module").then(
            (m) => m.CountryModule,
          ),
      },
      {
        path: "province",
        loadChildren: () =>
          import("./../../views/pages/master/province/province.module").then(
            (m) => m.provinceModule,
          ),
      },
      {
        path: "group",
        loadChildren: () =>
          import("./../../views/pages/master/group/group.module").then(
            (m) => m.GroupModule,
          ),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class LayoutRoutingModule {}
